import { render, staticRenderFns } from "./Meal2.vue?vue&type=template&id=0221035a&scoped=true&"
import script from "./Meal2.vue?vue&type=script&lang=js&"
export * from "./Meal2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0221035a",
  null
  
)

export default component.exports